import {createTheme, ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import {BrowserRouter, Routes, Route, Navigate} from "react-router-dom";
import {WordPressQuote} from "./components/WordPressQuote/WordPressQuote";
import {green, light_green} from "./Utils/style";
import {WordPressCalculator} from "./components/WordPressCalculator/WordPressCalculator";
import {
    WordPressMultiConversationChatBot
} from "./components/WordPressMultiConversationChatBot/WordPressMultiConversationChatBot";
import UUCargoTheme from './components/Theme/UUCargoTheme';
import {WordPressTools} from "./components/WordPressTools/WordPressTools";
import CloudflareTurnstile from "./components/Cpatcha/CloudflareTurnstile";

function App() {
    return (
        <ThemeProvider theme={UUCargoTheme}>
            <CssBaseline/> {/* This helps with consistent baseline styles */}
            <BrowserRouter basename={'/embedded'}>
                <CloudflareTurnstile>
                    <Routes>
                        <Route path="/" element={<div>Hello Embedded</div>}/>
                        <Route exact
                               path="/wordPressQuote/:tab/:lng"
                               element={<WordPressQuote/>}
                        />
                        <Route exact
                               path="/wordPressCalculator/:tab/:lng"
                               element={<WordPressCalculator/>}
                        />
                        <Route exact
                               path="/wordPressMultiConversationChatBot/:lng"
                               element={<WordPressMultiConversationChatBot/>}
                        />
                        <Route exact
                               path="/wordPressTools/:tab/:lng"
                               element={<WordPressTools/>}
                        />
                        {/* fallback route */}
                        <Route path="*" element={<div>404 Not Found</div>}/>
                    </Routes>
                </CloudflareTurnstile>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
